import _mapInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/map';
import React from 'react';
import PropTypes from 'prop-types';
import bemCnFast from 'bem-cn-fast';
import cn from 'classnames';
import { useTextStyles } from '@rescui/typography';
import { ThemeProvider } from '@rescui/ui-contexts';
import { defaultLinks } from './constants.js';

var bemCn = bemCnFast('error-page');
var ErrorPageContent = function ErrorPageContent(_ref) {
  var codeError = _ref.codeError,
    title = _ref.title,
    text = _ref.text,
    _ref$links = _ref.links,
    links = _ref$links === void 0 ? defaultLinks : _ref$links,
    children = _ref.children,
    footer = _ref.footer,
    className = _ref.className;
  var isTitleOrText = title || text;
  var textCn = useTextStyles();
  return React.createElement("div", {
    className: cn(bemCn(), className),
    "data-test": 'error-page'
  }, React.createElement("section", {
    className: cn(bemCn('main-section'), 'wt-container')
  }, React.createElement("h1", {
    className: bemCn('code'),
    "data-test": 'code'
  }, codeError), React.createElement("div", {
    className: cn(bemCn('content'), 'wt-offset-top-sm-32'),
    "data-test": 'content'
  }, title && React.createElement("h2", {
    className: textCn('rs-h2'),
    "data-test": 'title'
  }, title), text && React.createElement("div", {
    className: cn(textCn('rs-text-1'), {
      'wt-offset-top-12': title
    }),
    "data-test": 'text'
  }, text), children && React.createElement("div", {
    className: cn({
      'wt-offset-top-24': isTitleOrText
    }),
    "data-test": 'children'
  }, children), links && React.createElement("ul", {
    className: cn(bemCn('links'), textCn('rs-text-1', {
      hardness: 'hard'
    }), {
      'wt-offset-top-24': isTitleOrText || children
    }),
    "data-test": 'links'
  }, _mapInstanceProperty(links).call(links, function (_ref2) {
    var value = _ref2.value,
      label = _ref2.label;
    return React.createElement("li", {
      key: label
    }, React.createElement("a", {
      className: cn(textCn('rs-link', {
        hardness: 'hard'
      })),
      href: value,
      "data-test": 'link'
    }, label));
  })))), footer);
};
var ErrorPage = function ErrorPage(_ref3) {
  var codeError = _ref3.codeError,
    title = _ref3.title,
    text = _ref3.text,
    _ref3$links = _ref3.links,
    links = _ref3$links === void 0 ? defaultLinks : _ref3$links,
    children = _ref3.children,
    footer = _ref3.footer,
    className = _ref3.className;
  return React.createElement(ThemeProvider, {
    theme: "dark"
  }, React.createElement(ErrorPageContent, {
    codeError: codeError,
    title: title,
    links: links,
    text: text,
    footer: footer,
    className: className
  }, children));
};
var ErrorPagePropTypes = {
  codeError: PropTypes.string.isRequired,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  links: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired
  })),
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.arrayOf(PropTypes.element)]),
  footer: PropTypes.oneOfType([PropTypes.element, PropTypes.arrayOf(PropTypes.element)]),
  className: PropTypes.string
};
ErrorPageContent.propTypes = ErrorPagePropTypes;
ErrorPage.propTypes = ErrorPagePropTypes;

export { ErrorPage };
